// Centralized site data for Sphère Auto

export const SITE = {
  name: "Sphère Auto",
  tagline: "Votre centre auto de confiance à Loos-en-Gohelle",
  email: "contact@sphereauto.net",
  phone: "0609032023",
  phoneDisplay: "06 09 03 20 23",
  phoneTel: "tel:+33609032023",
  address: {
    street: "55 rue Jules Supervielle",
    zip: "62750",
    city: "Loos-en-Gohelle",
    full: "55 rue Jules Supervielle, 62750 Loos-en-Gohelle",
  },
  hours: {
    days: "Lundi - Samedi",
    time: "9h00 - 18h00",
    closed: "Fermé Dimanche",
    emergency: "Dépannage 24h/24 — 7j/7",
  },
  logo: {
    light: "https://customer-assets.emergentagent.com/job_garage-loss/artifacts/56ond9an_IMG-20260212-WA0040%282%29.jpg",
    dark: "https://customer-assets.emergentagent.com/job_garage-loss/artifacts/qflfj0pa_B33EE366-4AC7-42C4-95EE-DBB6F393DF3F.PNG",
  },
};

export const SERVICES = [
  {
    id: "carte-grise",
    title: "Carte Grise",
    desc: "Service habilité pour vos démarches d'immatriculation : duplicata, changement de propriétaire, déclaration de cession.",
    icon: "FileText",
  },
  {
    id: "mecanique",
    title: "Mécanique",
    desc: "Entretien, révision, freinage, distribution, embrayage. Tout type de marque, équipement moderne.",
    icon: "Wrench",
  },
  {
    id: "depannage",
    title: "Dépannage",
    desc: "Assistance et remorquage rapide. Intervention sur le secteur de Loos-en-Gohelle et alentours.",
    icon: "Truck",
  },
  {
    id: "achat-vente",
    title: "Achat / Vente / Reprise",
    desc: "Estimation honnête et reprise de votre véhicule. Sélection de véhicules d'occasion contrôlés.",
    icon: "Car",
  },
  {
    id: "pieces-auto",
    title: "Pièces Auto",
    desc: "Pièces détachées d'origine et adaptables, à prix juste. Commande rapide pour toutes marques.",
    icon: "Cog",
  },
  {
    id: "diag-offert",
    title: "Diagnostic Offert",
    desc: "Diagnostic électronique multimarque offert pour identifier la panne avant tout devis.",
    icon: "Gauge",
  },
];

export const HIGHLIGHTS = [
  { label: "Diag offert", icon: "Gauge" },
  { label: "Devis 24/48h", icon: "Clock" },
  { label: "Équipe à l'écoute", icon: "Heart" },
];

export const TIME_SLOTS = [
  "09:00", "09:30", "10:00", "10:30", "11:00", "11:30",
  "14:00", "14:30", "15:00", "15:30", "16:00", "16:30", "17:00", "17:30",
];

export const SERVICE_OPTIONS = SERVICES.map((s) => s.title).concat(["Devis", "Autre"]);
